module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-always-inspired-large-cac0b4110e6e457ab1b908c1584fffe5.jpg";